module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_one_has_written_yet":"No one has reviewed this product yet.","no_one_who_has_type_has_written_yet_html":"Customers with {userPropertyTypeOptionName} type have not reviewed this product yet.","should_write_review":"Be the first to write a review!","write_review":"Write a review"}}')
  delete Component.options._Ctor
}
